import { Col, Container, Row } from "react-bootstrap";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useLocation } from "react-router-dom";
import Checkout from "./checkout";
import Text from "../../views/text/text";
import Title from "../../views/title/title";
import './stripeo.css';
import successImage from './images/check.png';
import pendingImage from './images/stopwatch.png';
import failedImage from './images/close.png';
import invalidImage from './images/minus.png';
import gtag from "../../core/utils/gtag";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const formatUsd = (value) => Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });



function Stripeo() {
  const {state} = useLocation();
  let paymentStatus = 0;

  const appearance = {
    theme: 'stripe',
    variables: {
      colorPrimary: '#005201',
      colorText: '#4c4d57',
    },
  };
  
  const options = {
    appearance,
    ...state
  };  


  const clientSecret = new URLSearchParams(window.location.search).get(
    "payment_intent_client_secret"
  );

  const redirectStatus = new URLSearchParams(window.location.search).get(
    "redirect_status"
  );

    
  if (clientSecret && redirectStatus) {

    switch (redirectStatus) {
      case "succeeded":
        paymentStatus = 1;
        gtag.event('payment_successful');
        break;
      case "processing":
      case "pending":
        paymentStatus = 2;
        gtag.event('payment_pending');
        break;
      case "requires_payment_method":
        paymentStatus = -1;
        gtag.event('payment_failed');
        break;
      default:
        paymentStatus = -1;
        gtag.event('payment_unknown');
        break;
    }
    const storageClientSecret = sessionStorage.getItem("pi_temp_code");
    if (clientSecret !== storageClientSecret) {
      paymentStatus = -2;
    } 
  } else {
    gtag.event('payment_initiated');
    sessionStorage.setItem("pi_temp_code", options.clientSecret);
    sessionStorage.setItem("payAmount", options.payAmount);
  }
   
  return (
      <>
        { (paymentStatus === 0) &&
         (<Container className="payment-container">
            <Row>
              <section><Title>Payment <strong>Information</strong></Title></section>
              <section><Text thin>Please provide your payment information</Text></section>
            </Row>
            {options.discountAmount > 0 && (
              <Row className="payment-amount-container payment-discount-breakdown">
                  <div><Text className="checkout-price-title">One-time setup fee: {formatUsd(options.payAmount + options.discountAmount)}</Text></div>
                  <div><Text className="checkout-price-title">Promotional discount: -{formatUsd(options.discountAmount)}</Text></div>
              </Row>
            )}
            <Row className="payment-amount-container">
                <div><Text className="checkout-price-title">Ontime Subscription Fee (One-time Payment)</Text></div>
                <div><Text heavy className="checkout-price-text">{formatUsd(options.payAmount)}</Text></div>
            </Row>
            <Row className="payment-details-container">
              <Col>
                {/* <div className="checkout-item-area"><Text>Software Subscription Fee  <span className="checkout-item-spacing"></span>$900.00</Text></div> */}
                
            <div className="checkout-subscription-area">
              <p className="checkout-subscription-note">
                <strong>One-time setup fee:</strong> This fee covers your onboarding and account setup in our system. <em>This charge will only be made once and is non-refundable.</em>
              </p>

              <p className="checkout-subscription-note">
                <strong>Subscription pricing:</strong> OnTime ITS pricing is fully usage-based.
              </p>

              <ul className="checkout-subscription-tiers">
                <li><strong>$199/month</strong> — for <em>0–10 active clients</em> or <em>employees (Staffing)</em>.</li>
                <li><strong>$499/month</strong> — for <em>11–50 active clients</em> or <em>employees (Staffing)</em>.</li>
                <li><strong>$10</strong> per active resource — if you have <em>more than 50</em>.</li>
              </ul>

              <div className="checkout-subscription-terms">
                <strong>OnTime ITS Subscription & Billing Terms</strong>             
                <p>
                  OnTime ITS is a subscription-based service. Monthly fees are calculated based on your selected pricing plan, industry classification, and number of active clients, patients, or employees during the preceding 30-day billing cycle.
                </p>

                <p>
                  An active client or patient is someone who received services, while an active employee is someone who performed work during that period. Individuals remaining on your roster without activity are excluded from usage-based charges.
                </p>

                <p>
                  Subscription fees may fluctuate monthly based on activity and applicable pricing tiers. Additional charges may apply for optional services, including payroll, integrations, training, and other platform features.
                </p>

                <p>
                  Account changes may adjust recurring payments or generate separate invoices. Your authorization is required before activating additional paid services. Subscriptions renew automatically until canceled under the applicable service agreement.
                </p>

                <p>
                  For billing questions or assistance, contact OnTime ITS Customer Relations.
                </p>
              </div>
            </div>



              </Col>
              <Col className="payment-sidebar">
                {options.clientSecret && (
                <Elements options={options} stripe={stripePromise}>
                  <Checkout />
                </Elements>
                )}
              </Col>
            </Row>
          </Container>)
        }

        { (paymentStatus === 1)  &&

          <Container className="payment-container">
            <Row>
              <section>
                <div>
                  <img alt="sucess-payment" src={successImage} className="payment-status-image"/> 
                </div>
                <div>
                  <Text className="payment-status-title" thin>Thank You! Your Payment was successful.</Text>
                  <Text thin>Please check your email inbox for a confirmation email regarding your recent purchase.</Text>
                  <Text thin>Please give it up to 15 minutes to arrive (make sure you check your Spam Folder if you have not received it).</Text>
                  <Text thin>If you have any questions or concerns feel free to <a href="/#contact">contact support here.</a></Text> 
                  <Text thin>Thank you so much for doing business with us.</Text>
                </div>
              </section>
            </Row>
          </Container>
        }

        { (paymentStatus === 2)  &&

          <Container className="payment-container">
            <Row>
              <section>
                <div>
                  <img alt="pending-payment" src={pendingImage} className="payment-status-image"/> 
                </div>
                <div>
                  <Text className="payment-status-title" thin>Thank You! Your Payment is processing.</Text>
                  <Text thin>Please check your email inbox for a confirmation email regarding your recent purchase.</Text>
                  <Text thin>Please give it up to 15 minutes to arrive (make sure you check your Spam Folder if you have not received it).</Text>
                  <Text thin>If you have any questions or concerns feel free to <a href="/#contact">contact support here.</a></Text> 
                  <Text thin>Thank you so much for doing business with us.</Text>
                </div>
              </section>
            </Row>
          </Container>
        }

        { (paymentStatus === -1)  &&

          <Container className="payment-container">
            <Row>
              <section>
                <div>
                  <img alt="failed-payment" src={failedImage} className="payment-status-image"/> 
                </div>
                <div>
                  <Text className="payment-status-title" thin>Sorry. Your Payment failed.</Text>
                  <Text thin>Sorry, your payment failed. No charges were made.</Text>
                  <Text thin>Please feel free to retry the payment with a different card.</Text>
                  <Text thin>If you have any questions or concerns feel free to <a href="/#contact">contact support here.</a></Text> 
                </div>
              </section>
            </Row>
          </Container>
        }

        { (paymentStatus === -2)  &&

          <Container className="payment-container">
            <Row>
              <section>
                <div>
                  <img alt="failed-payment" src={invalidImage} className="payment-status-image"/> 
                </div>
                <div>
                  <Text className="payment-status-title" thin>Oops!!. It's an expired transaction.</Text>
                  <Text thin>Sorry, This transaction has been expired. Invalid Payment ID found</Text>
                  <Text thin>If you think this is a wrong information Please <a href="/#contact">contact support here.</a></Text> 
                </div>
              </section>
            </Row>
          </Container>
        }
      </>
  );
}

export default Stripeo;